const SwedenSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112495)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FFDA44"
      />
      <path
        d="M15.6519 17.3913H39.8304C38.552 7.57828 30.1612 0 19.9997 0C18.5064 0 17.0518 0.165078 15.6519 0.475391V17.3913H15.6519Z"
        fill="#0052B4"
      />
      <path
        d="M10.4344 17.3921V2.43262C4.9427 5.42902 1.01137 10.9252 0.168945 17.3921H10.4344V17.3921Z"
        fill="#0052B4"
      />
      <path
        d="M10.4343 22.6084H0.168945C1.01137 29.0754 4.9427 34.5715 10.4344 37.5679L10.4343 22.6084Z"
        fill="#0052B4"
      />
      <path
        d="M15.6519 22.6085V39.5243C17.0518 39.8347 18.5064 39.9997 19.9997 39.9997C30.1612 39.9997 38.552 32.4214 39.8304 22.6084H15.6519V22.6085Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112495">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SwedenSvg;
